import { Injectable } from '@angular/core';
import { WebApiService } from '../../web-api.service';
import { WebApiClient } from '../../web-api-client.service';

/** 參數設定DTO */
export class ParameterSetDto {
  ClinicId: number;
  DeclareWay: number;
  DeclareType: number;
  DeclareMonth: Date;
  DeclareDate: Date;
  DeclareClass: number;
  /** 醫藥分業日 */
  MedDivSdate: Date;
  CoincideDrugStandard: number;
  /** 列出未還單 (Y/N) */
  NoReturnList: number;
  /** 列出轉診名單(Y/N) */
  ShowReferralList: number;
  ErrorMsgShowing: number;
  Pharmacist: number;
  Kidneydialysis: number;
  SameTreatment: number;
  Dental: number;
  /** 是否顯示 藥費+診療金額為零(E11A2、E11A6為0) 的警示 */
  IsZero: number;
  /** 護理人員加計 */
  NursePlus: number;
  JobDisease: number;
  /** 補報次別 */
  AmendNum: string | number;
  /** 超過X次警告 */
  OverTimes: number;
  /** 純注射設調劑6 (Y/N) */
  InjectDispTP: number;
  /** 是否將慢病09專案改04案類申報 (Y/N) */
  TranChronic4: number;
  /** 是否顯示慢病09專案警示訊息 (Y/N) */
  ShowTranChronic4: number;
  /** 牙醫 貴院所是否符合加強感染控制SOP(評分85分以上) */
  InfectionControlRatingPoints: number;
  /** 牙醫 貴院所是否符合加強感染控制SOP(偏遠醫療巡診) */
  InfectionControlRemoteMedical: number;
  /** 支援藥師遞補設定 */
  PartPharmacist: number;
  /** 專任藥師人數 */
  PharmacistNum: number;
  /** 中醫-是否有藥師(1聘有藥師 2中醫師親自調劑 3不申請調劑費) */
  ChinesePharmacist: number;
  /** 中醫-藥師請假調劑方式(1.依然申報調劑費(提醒無填入藥師) 2.中醫師親自調劑 3.不申請調劑費) */
  ChinesePhLeaveTP: number;
  /** 是否為院所自行決定申報給藥日份，若診所參數設定true，則依照3L的給藥日份為主 */
  DeclareFreeDay: boolean;
  /** 同療第2-6次有藥事費 (Y/N) */
  IsCusA99: number;
  /** 是否為更換醫事機構代號 */
  IsChangeNHICode: boolean;
  /** 本次申報的醫事機構代號(用於更換醫事機構代號時，要指定申報的) */
  SetNHICode: string;
  /** 藥局不符設立標準 [Y]門前藥局　[N]獨立藥局 */
  PharmType: number;
  /** 藥局-慢箋拿藥是否提示同人同月同卡序 (Y/N) */
  ShowPresSameMsg: number;
  /** 藥局-每日平均藥費上限警告-上限值 */
  A2FeeLimit: number;
  /** 新政令：不申報的卡序 格式：[卡序=政令開始日,卡序2=政令開始日2] */
  ExcludeIsqno: string;
  /** 牙醫-是否申報調劑費 */
  IsDentisitAMed: boolean;
  /** 山地離島地區實施計畫代碼 IDS計畫<d48> */
  MountainIDSCodeD48: string;
  /** 是否糖尿病團隊醫師有兼任護理師、營養師、藥師任一專業人員執行業務(Y/N) */
  DMteamDrMultipleRole: string;
}

@Injectable({
  providedIn: 'root'
})
export class ParamSetApi {
  api: WebApiService;
  constructor(
    private apiClient: WebApiClient) {
    this.api = this.apiClient.createHisService('declares/ParameterSet');
    this.api.enableLoader = true;
  }

  /** 取得最近一筆參數設定 */
  public async GetLast(clinicId: number, month: string, type: number,amenNum:string): Promise<ParameterSetDto> {
    var data = await this.api.get('GetLast?clinicId=' + clinicId + '&month=' + month + '&type=' + type+'&amenNum='+amenNum).toPromise<ParameterSetDto>();
    // 因為此DTO帶有方法，所以要另外NEW =>Object.assign(new ParameterSetDto(), data);
    return data;
  }

  /** 新增 */
  public async Create(data: ParameterSetDto): Promise<boolean> {
    return await this.api.post('Create', data).toPromise<boolean>()
  }
}
